// extracted by mini-css-extract-plugin
export default {"categoryFilter":"styles_categoryFilter__1iGSi"};